// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__23oQu","detailsBorder":"styles_detailsBorder__1MVmN"};